import type { ReactNode } from "react";
import { createContext } from "react";

import { NcRouterProvider } from "./nc-router-provider";

const defaultValue = {
  t: (value: string) => value,
  locale: "en-NZ",
};

type NcGlobalContextValue = {
  t: (value: string, params?: { [key: string]: string }) => string;
  locale: string;
};

export const NcGlobalContext = createContext<NcGlobalContextValue>(defaultValue);

export const NcGlobalProvider = ({
  value,
  children,
}: {
  value: NcGlobalContextValue;
  children: ReactNode;
}) => (
  <NcGlobalContext.Provider value={value || defaultValue}>
    <NcRouterProvider>{children}</NcRouterProvider>
  </NcGlobalContext.Provider>
);
